import ProgressBar from "./ProgressBar";
import styles from "./ProgressBar.module.css";

interface RecordProgressProps {
  numberOfRecords: number;
  limit: number;
}

const RecordProgress: React.FC<RecordProgressProps> = ({
  numberOfRecords,
  limit,
}) => {
  const percentage = (numberOfRecords / limit) * 100;

  return (
    <div className={styles.container}>
      <ProgressBar percentage={percentage} />
      <div className={styles.text}>
        {`${numberOfRecords} record${
          numberOfRecords === 1 ? "" : "s"
        } (${percentage.toFixed(1)}%) `}
        <span>{`${limit / 1000}k limit`}</span>
      </div>
    </div>
  );
};

export default RecordProgress;
